<template>
    <div id="layoutSidenav_nav">
        <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
            <div class="sb-sidenav-menu">
                <ul class="nav" v-for="(item, id) in menu" :key="id" >
                    <router-link class="nav-link" :to="{name: item.route}" v-if="item.children.length == 0" >
                        <div class="sb-nav-link-icon">
                            <font-awesome-icon :icon="item.icon" /> &nbsp;
                        </div>
                        <span>{{item.name}}</span>
                    </router-link>
                    <li class="nav-item" v-else >
                        <a class="nav-link" v-b-toggle :href="'#sub-' +id" >
                            <div class="sb-nav-link-icon">
                                <font-awesome-icon :icon="item.icon" />&nbsp;
                            </div>
                            <span>{{item.name}}</span>
                        </a>
                        <b-collapse class="sub-menu" :id="'sub-' +id" >
                            <ul class="navbar-nav">
                                <li class="nav-item" v-for="(subitem, i) in item.children" :key="item.name + '-' + i" >
                                    <template v-if="subitem.children.length == 0" >
                                        <router-link class="nav-link" :to="{name: subitem.route}" >
                                            <div class="sb-nav-link-icon">
                                                <font-awesome-icon :icon="subitem.icon" />&nbsp;
                                            </div>
                                            <span>{{subitem.name}}</span>
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        <a class="nav-link" v-b-toggle :href="'#sub-item-' +i" >
                                            <div class="sb-nav-link-icon">
                                                <font-awesome-icon :icon="subitem.icon" />&nbsp;
                                            </div>
                                            <span>{{subitem.name}}</span>
                                        </a>
                                        <b-collapse class="sub-menu" :id="'sub-item-' +i" >
                                            <ul class="navbar-nav">
                                                <li class="nav-item" v-for="(si, siId) in subitem.children" :key="subitem.name + '-' + siId" >
                                                    <router-link class="nav-link" :to="{name: si.route}" >
                                                        <div class="sb-nav-link-icon">
                                                            <font-awesome-icon :icon="si.icon" />&nbsp;
                                                        </div>
                                                        <span>{{si.name}}</span>
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </b-collapse>
                                    </template>
                                </li>
                            </ul>
                        </b-collapse>
                    </li>
                </ul>
            </div>
            <div class="sb-sidenav-footer" >
                <p style="margin: 0">
                    <small>V-1.0.0-Beta</small>
                </p>
                <p style="margin: 0"  >
                    <small>
                        Jointech Tecnologia em Sistemas
                    </small>
                </p>
            </div>
        </nav>
    </div>
</template>
<script>
    export default {
        name: 'sideBar',
        methods: {
            toggleMenu: function(){
                let menu = document.getElementById('navbar-toggle')
                menu.classList.toggle('toggled')
            }
        },
        data: () => ({
            menu: [
                {
                    name: 'Ínicio',
                    icon: 'home',
                    route: 'home',
                    children: []
                },
                {
                    name: 'Clientes',
                    icon: 'users',
                    route: 'clients',
                    children: []
                },
                {
                    name: 'Estoque',
                    icon: 'boxes',
                    route: '',
                    children: [
                        {
                            name: 'Produtos',
                            icon: 'boxes',
                            route: '',
                            children: [
                                {
                                    name: 'Todos',
                                    icon: 'boxes',
                                    route: 'produtos.todos',
                                    children: []
                                },      
                                {
                                    name: 'Novo',
                                    icon: 'boxes',
                                    route: 'produtos.novo',
                                    children: []
                                },      
                            ]
                        },
                        {
                            name: 'Grupos',
                            icon: 'boxes',
                            route: '',
                            children: [
                                {
                                    name: 'Todos',
                                    icon: 'boxes',
                                    route: 'grupos.todos',
                                    children: []
                                },      
                                {
                                    name: 'Novo',
                                    icon: 'boxes',
                                    route: 'grupos.novo',
                                    children: []
                                },      
                            ]
                        },
                        {
                            name: 'Sub Grupos',
                            icon: 'boxes',
                            route: '',
                            children: [
                                {
                                    name: 'Todos',
                                    icon: 'boxes',
                                    route: 'subgrupo.todos',
                                    children: []
                                },      
                                {
                                    name: 'Novo',
                                    icon: 'boxes',
                                    route: 'subgrupo.novo',
                                    children: []
                                },      
                            ]
                        },
                    ]
                },
                {
                    name: 'Gestor Food',
                    icon: 'utensils',
                    route: '',
                    children: [
                        {
                            name: '(B) Mesas',
                            icon: 'table',
                            route: 'mesas.mapa',
                            children: []
                        },
                    ]
                },
                {
                    name: 'Financeiro',
                    icon: 'calendar-alt',
                    route: '',
                    children: [
                        {
                            name: '(B) Entradas',
                            icon: 'calendar-alt',
                            route: 'movimentToReceive',
                            children: []
                        },
                        {
                            name: '(B) Nova entrada',
                            icon: 'calendar-alt',
                            route: 'newMovimentToReceive',
                            children: []
                        },
                        {
                            name: '(B) Saídas',
                            icon: 'calendar-alt',
                            route: 'movimentToPay',
                            children: []
                        },
                        {
                            name: '(B) Nova Saída',
                            icon: 'calendar-alt',
                            route: 'newMovimentToPay',
                            children: []
                        },
                    ]
                },
            ]
        })
    }
</script>
<style scoped>
    .sub-menu{
        padding-left: 40px;
    }
</style>